<template>
  <vue-modal no-close ref="modal">
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:default>
      <div v-if="loading">
        <div class="loading-shade"></div>
        <pre-loader></pre-loader>
      </div>

      <div class="container-terms-modal">
        <div>
          We have made important updates to our Terms and Conditions, Betting Rules, and Responsible Gambling Policy. <br />
          These changes include clarifications on how we operate, customer protections, and your rights when using our services.<br />
          Please take a moment to review the updated documents. The changes will take effect on 9 May 2025.<br> By continuing to use your account after this date, you are agreeing to the updated Terms. Click <a @click="setShowInfoInModal('Terms And Conditions')" href="javascript://">here</a>  to review the updates in full.
        </div>

        <vue-checkbox 
          class="checkbox-input"
          v-model="model.terms"
          description="'terms'"
          name="cbx-terms"
        >
          <div class="agree-terms lbl-required">Terms and Conditions</div>
        </vue-checkbox>
        <vue-checkbox 
          class="checkbox-input"
          v-model="model.betting"
          description="'betting'"
          name="cbx-betting"
        >
          <div class="agree-terms lbl-required">Betting Rules</div>
        </vue-checkbox>
        <vue-checkbox 
          class="checkbox-input"
          v-model="model.gambling"
          description="'gambling'"
          name="cbx-gambling"
        >
          <div class="agree-terms lbl-required">Responsible Gambling Policy</div>
        </vue-checkbox>

        <vue-checkbox 
          class="checkbox-input"
          v-model="selectAll"
          description="'all'"
          name="cbx-all"
        >
          <div class="agree-terms lbl-required">Accept All</div>
        </vue-checkbox>
        
      </div>
      <vue-button 
        type="button"
        @click="submitForm"
        :disabled="!isAllAnswered"
        :cls="isAllAnswered ? 'main': 'disable'">Submit</vue-button>

    </template>
  </vue-modal>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/UI/PreLoader";
import VueModal from "@/components/UI/VueModal";
import VueButton from "@/components/UI/VueButton";
import VueCheckbox from "@/components/UI/VueCheckbox";

export default {
  name: "AcceptTermsModal",
  components: {
    VueModal,
    VueButton,
    VueCheckbox,
    PreLoader
  },
  data: () => {
    return {
      loading: false,
      model: {
        terms: null,
        betting: null,
        gambling: null,
        all: null
      }
    }
  },
  computed: {
    ...mapGetters(['USER', 'SHOW_INFO_IN_MODAL']),
    isAllAnswered() {
      return !!this.model.terms && !!this.model.betting && !!this.model.gambling
    },
    selectAll: {
        get: function () {
            return this.model.terms && this.model.betting && this.model.gambling 
        },
        set: function (value) {
            this.model.terms = value
            this.model.betting = value
            this.model.gambling = value
        }
    }
  },
  watch: {
    'USER.isAcceptTermsModal'() {
      this.initPopupState()
    },
  },
  mounted() {
    this.initPopupState()
  },
  methods:{

    initPopupState() {
      if (this.USER?.isAcceptTermsModal) {
        this.$refs.modal.open()
      }
      else (
        this.$refs.modal.close()
      )
    },
    submitForm() {
      this.loading = true;
      this.API.postTermsAccepted()
        .then((data) => {
          if (data?.isTermsAndConditionsAccepted) {
            this.API.getIsShowTermsModal()
              .then((data) => {
                this.$store.dispatch('SET_USER_DATA', {
                  isAcceptTermsModal: data.isShowModal
                }).then(() => {
                  this.$router.push({name: 'home'})
                })
              })
              .catch(err => {
                console.log('getIsShowTermsModal err', err)
                this.$toast.error('We’re currently unable to load the policy update notice. For your security and compliance, access to the platform is temporarily restricted. Please try again shortly or contact support if the issue persists')
              })
              .finally(() => {
                this.loading = false
              })
          }
          else {
            this.loading = false
            this.$toast.error('Something went wrong. Please try again later')
          }
        })
        .catch((err) => {
          console.log('postTermsAccepted', err)
          this.$toast.error('Something went wrong. Please try again later')
          this.loading = false
        })
      
     
    },
    setShowInfoInModal(val) {
      this.$store.dispatch('SET_SHOW_INFO_IN_MODAL', true)
        .then(() => {
          this.$router.push( {name:'info', params: { infoType: val }})
        })

    }
  }
}
</script>

<style scoped lang="scss">
.content{
  max-width: 400px;
}

.container-survey,
.container-terms-modal {
  margin: 0 0 1rem;
  max-width: 60vw;
  @media only screen and (max-width: 1024px){
    max-width: unset;
  }

  .survey-item {
    display: grid;
    grid-template-columns: 80% 1fr 1fr;
    align-items: center;
    text-align: center;
    margin-bottom: 1rem;

    >div:first-child {
      text-align: left;
    }

    &.title {
      text-transform: uppercase;
    }
  }

  .result {
    margin-bottom: 1rem;
  }
}
</style>